<script>
  import { getExtension, removeExtension, buildSrc, replaceSizeInUrl } from '../utils/imageUtils.js';

  export let src = '';
  export let alt = '';
  export let width;
  export let height;

  let extension = getExtension(src);

  let baseUrl = removeExtension(src);

  // Example for smaller screens (256) vs. normal (512)
  // – adjust to suit your actual usage
  let smallSrc = replaceSizeInUrl(src, '512', '256');
  let smallBaseUrl = removeExtension(smallSrc);
</script>

<picture>
  <!-- Prefer .webp for smaller screens if you want -->
  <source srcset={buildSrc(smallBaseUrl, 'webp')} type="image/webp" media="(max-width: 500px)" />
  <!-- Next bigger .webp for mid-sized devices -->
  <source srcset={buildSrc(baseUrl, 'webp')} type="image/webp" media="(max-width: 1024px)" />
  <!-- Fallback to the original extension -->
  <source srcset={buildSrc(baseUrl, extension)} type="image/{extension}" />
  <!-- Actual fallback <img> tag -->
  <img class="product-image" src={buildSrc(smallBaseUrl, extension)} {alt} style="width:{width}; height:{height}" />
</picture>

<style>
  .product-image {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
    max-width: 100%;
    max-height: 100%;
  }
</style>
